import { z } from 'zod';

export const itemLevelSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  level: z.number().int(),
  organizationId: z.string().min(1),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
  createdBy: z.string(),
  updatedBy: z.string(),
});

export type ItemLevelDTO = z.infer<typeof itemLevelSchema>;
